/* import __COLOCATED_TEMPLATE__ from './feature-topic.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import EmberObject, { action } from "@ember/object";
import { service } from "@ember/service";
import { categoryLinkHTML } from "discourse/helpers/category-link";
import { ajax } from "discourse/lib/ajax";
import I18n from "discourse-i18n";
import TEMPLATE from "./feature-topic.hbs";
import { setComponentTemplate } from "@ember/component";
export default class FeatureTopic extends Component {
  static #_ = (() => dt7948.g(this.prototype, "currentUser", [service]))();
  #currentUser = (() => (dt7948.i(this, "currentUser"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "dialog", [service]))();
  #dialog = (() => (dt7948.i(this, "dialog"), void 0))();
  static #_3 = (() => dt7948.g(this.prototype, "loading", [tracked], function () {
    return true;
  }))();
  #loading = (() => (dt7948.i(this, "loading"), void 0))();
  static #_4 = (() => dt7948.g(this.prototype, "pinnedInCategoryCount", [tracked], function () {
    return 0;
  }))();
  #pinnedInCategoryCount = (() => (dt7948.i(this, "pinnedInCategoryCount"), void 0))();
  static #_5 = (() => dt7948.g(this.prototype, "pinnedGloballyCount", [tracked], function () {
    return 0;
  }))();
  #pinnedGloballyCount = (() => (dt7948.i(this, "pinnedGloballyCount"), void 0))();
  static #_6 = (() => dt7948.g(this.prototype, "bannerCount", [tracked], function () {
    return 0;
  }))();
  #bannerCount = (() => (dt7948.i(this, "bannerCount"), void 0))();
  static #_7 = (() => dt7948.g(this.prototype, "pinInCategoryTipShownAt", [tracked], function () {
    return false;
  }))();
  #pinInCategoryTipShownAt = (() => (dt7948.i(this, "pinInCategoryTipShownAt"), void 0))();
  static #_8 = (() => dt7948.g(this.prototype, "pinGloballyTipShownAt", [tracked], function () {
    return false;
  }))();
  #pinGloballyTipShownAt = (() => (dt7948.i(this, "pinGloballyTipShownAt"), void 0))();
  constructor() {
    super(...arguments);
    this.loadFeatureStats();
  }
  get categoryLink() {
    return categoryLinkHTML(this.args.model.topic.category, {
      allowUncategorized: true
    });
  }
  get unPinMessage() {
    let name = "topic.feature_topic.unpin";
    if (this.args.model.topic.pinned_globally) {
      name += "_globally";
    }
    if (moment(this.args.model.topic.pinned_until) > moment()) {
      name += "_until";
    }
    const until = moment(this.args.model.topic.pinned_until).format("LL");
    return I18n.t(name, {
      categoryLink: this.categoryLink,
      until
    });
  }
  get canPinGlobally() {
    return this.currentUser.canManageTopic && this.args.model.topic.details.can_pin_unpin_topic;
  }
  get pinMessage() {
    return I18n.t("topic.feature_topic.pin", {
      categoryLink: this.categoryLink
    });
  }
  get alreadyPinnedMessage() {
    const key = this.pinnedInCategoryCount === 0 ? "topic.feature_topic.not_pinned" : "topic.feature_topic.already_pinned";
    return I18n.t(key, {
      categoryLink: this.categoryLink,
      count: this.pinnedInCategoryCount
    });
  }
  get pinDisabled() {
    return !this._isDateValid(this.parsedPinnedInCategoryUntil);
  }
  get pinGloballyDisabled() {
    return !this._isDateValid(this.parsedPinnedGloballyUntil);
  }
  get parsedPinnedInCategoryUntil() {
    return this._parseDate(this.args.model.topic.pinnedInCategoryUntil);
  }
  get parsedPinnedGloballyUntil() {
    return this._parseDate(this.args.model.topic.pinnedGloballyUntil);
  }
  get pinInCategoryValidation() {
    if (this.pinDisabled) {
      return EmberObject.create({
        failed: true,
        reason: I18n.t("topic.feature_topic.pin_validation")
      });
    }
  }
  get pinGloballyValidation() {
    if (this.pinGloballyDisabled) {
      return EmberObject.create({
        failed: true,
        reason: I18n.t("topic.feature_topic.pin_validation")
      });
    }
  }
  _parseDate(date) {
    return moment(date, ["YYYY-MM-DD", "YYYY-MM-DD HH:mm"]);
  }
  _isDateValid(parsedDate) {
    return parsedDate.isValid() && parsedDate > moment();
  }
  async loadFeatureStats() {
    try {
      this.loading = true;
      const result = await ajax("/topics/feature_stats.json", {
        data: {
          category_id: this.args.model.topic.category.id
        }
      });
      if (result) {
        this.pinnedInCategoryCount = result.pinned_in_category_count;
        this.pinnedGloballyCount = result.pinned_globally_count;
        this.bannerCount = result.banner_count;
      }
    } finally {
      this.loading = false;
    }
  }
  static #_9 = (() => dt7948.n(this.prototype, "loadFeatureStats", [action]))();
  async _confirmBeforePinningGlobally() {
    if (this.pinnedGloballyCount < 4) {
      this.args.model.pinGlobally();
      this.args.closeModal();
    } else {
      this.dialog.yesNoConfirm({
        message: I18n.t("topic.feature_topic.confirm_pin_globally", {
          count: this.pinnedGloballyCount
        }),
        didConfirm: () => {
          this.args.model.pinGlobally();
          this.args.closeModal();
        }
      });
    }
  }
  pin() {
    if (this.pinDisabled) {
      this.pinInCategoryTipShownAt = Date.now();
    } else {
      this.args.model.togglePinned();
      this.args.closeModal();
    }
  }
  static #_10 = (() => dt7948.n(this.prototype, "pin", [action]))();
  pinGlobally() {
    if (this.pinGloballyDisabled) {
      this.pinGloballyTipShownAt = Date.now();
    } else {
      this._confirmBeforePinningGlobally();
    }
  }
  static #_11 = (() => dt7948.n(this.prototype, "pinGlobally", [action]))();
  unpin() {
    this.args.model.togglePinned();
    this.args.closeModal();
  }
  static #_12 = (() => dt7948.n(this.prototype, "unpin", [action]))();
  makeBanner() {
    this.args.model.makeBanner();
    this.args.closeModal();
  }
  static #_13 = (() => dt7948.n(this.prototype, "makeBanner", [action]))();
  removeBanner() {
    this.args.model.removeBanner();
    this.args.closeModal();
  }
  static #_14 = (() => dt7948.n(this.prototype, "removeBanner", [action]))();
}
setComponentTemplate(TEMPLATE, FeatureTopic);